import { withDefaultContextAsSelectedProject } from 'api/api-default-context';
import { getUrlParam } from 'utils/project-utils';

export const closeSocketClientRequest = ({ revisionId, connectionId }) =>
  withDefaultContextAsSelectedProject().delete(
    `/tieout/api/close/revision/${revisionId}/connection/${connectionId}`,
  );

export const removeUserFromRoom = ({
  revisionId,
  projectUserIds,
  projectId,
}) => {
  const { urlProjectId, urlRevisionId } = getUrlParam();
  const projId = projectId || urlProjectId;
  const revId = revisionId || urlRevisionId;

  return withDefaultContextAsSelectedProject()
    .delete(
      `/tieout/project/${parseInt(projId)}/revision/${revId}/socketio/group/user`,
      {
        data: projectUserIds,
      },
    )
    .then((response) => response);
};

export const addUserToGroup = ({ revisionId, projectUserIds, projectId }) => {
  const { urlProjectId, urlRevisionId } = getUrlParam();
  const projId = projectId || urlProjectId;
  const revId = revisionId || urlRevisionId;

  return withDefaultContextAsSelectedProject().post(
    `/tieout/project/${parseInt(projId)}/revision/${revId}/socketio/group/user`,
    projectUserIds,
  );
};
